export default __webpack_public_path__ + "static/media/construction.81685603.png";